import React from 'react';
import { Box, Text, VStack, Spinner, BoxProps } from '@chakra-ui/react';

type AnalyzingSpinnerProps = {
  message: string;
  boxProps?: BoxProps;
};

export const AnalyzingSpinner: React.FC<AnalyzingSpinnerProps> = ({
  message = 'Analyzing...',
  boxProps,
}) => {
  return (
    <Box
      w="100%"
      h="433px"
      bg="surface.card"
      borderRadius="16px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxShadow="sm"
      border="1px solid"
      borderColor="border.light.box"
      fontFamily="marketingPage"
      {...boxProps}>
      <VStack spacing={6} align="center">
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="icon.green"
          size="xl"
        />
        <Text
          fontSize="lg"
          color="text.light.primary"
          fontWeight={500}
          textAlign="center">
          {message}
        </Text>
      </VStack>
    </Box>
  );
};
